import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { SBrand } from '../../rest/types/api/Brand'
import { SRetailer } from '../../rest/types/api/Retailer'
import { lowestNumberHelpers } from '../../helpers/LowestNumberHelpers'
import { ImageTransformer } from '../Transformers/ImageTransformer'
import Router from '../../routes/Router'
import routes from '../../routes/definitions'
import { selectors } from '../../redux'

const useCardProps = ({
  data,
  typeOfCard,
}: {
  data?: SBrand | SRetailer | null
  typeOfCard?: 'retailer' | 'brand'
}) => {
  const { t } = useTranslation()
  const isConnected = useSelector(selectors.auth.isConnected)

  const minNumber = useMemo(() => {
    const priceArray: number[] = []
    data?.offers?.forEach((item: any) =>
      item?.card?.forEach((elt: any) => {
        elt?.price &&
          priceArray.push(
            Number(parseFloat(elt.price.replace(/,/g, '.')).toFixed(2))
          )
      })
    )

    return priceArray.length ? lowestNumberHelpers(priceArray) : undefined
  }, [data?.offers])

  return data
    ? {
        image: ImageTransformer(data?.image),
        category: typeOfCard === 'retailer' ? 'Distributeur' : 'Marque',
        retailerWebSiteLink: {
          text: data?.name,
          href: data?.link?.href,
          target: data?.link?.target,
        },
        description: data?.shortDescription ?? '',
        numberOffers:
          data?.offers?.length && data.offers.length > 1
            ? `${data.offers.length} ${t('offers_label')}`
            : `${data?.offers?.length ?? 0} ${t('offer_label')}`,
        ...(minNumber &&
          isConnected && {
            minPrice: `${t('from_price_label')} ${minNumber
              .toString()
              .replace('.', ',')}${t('currency')}`,
          }),
        otherOffersLink: {
          href:
            typeOfCard === 'brand'
              ? Router.getRouteUrl(routes.brand, { slug: data?.slug })
              : typeOfCard === 'retailer'
              ? Router.getRouteUrl(routes.retailer, { slug: data?.slug })
              : undefined,
        },
      }
    : undefined
}

export default useCardProps
